import { useNavigation } from "hooks/navigate";
import {
  ArrowDownToLineIcon,
  HouseIcon,
  LayersIcon,
  PlusIcon,
  ReceiptIcon,
} from "lucide-react";
import { useI18n } from "providers/I18nProvider";
import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import { BottomNavigationBar } from "../BottomNavigationBar";
import { BottomNavigationButton } from "../BottomNavigationButton";
import { BottomNavigationItem } from "../types";

export const EmployeeBottomNavigation = () => {
  const { t } = useI18n();
  const navigate = useNavigation();
  const { pathname } = useLocation();
  const { employmentId, productAssignmentId } = useParams();

  const items = useMemo((): BottomNavigationItem[] => {
    const basePath = `/employment/${employmentId}/${productAssignmentId}`;

    return [
      {
        id: "dashboard",
        text: t("apps.employee.navigation.dashboard"),
        icon: <HouseIcon size="1.25rem" className="rtl:-scale-x-100" />,
        onClick: () => navigate(`${basePath}/dashboard`),
        active: pathname.includes("/dashboard"),
      },
      {
        id: "deposit",
        text: t("apps.employee.pages.dashboard.page.actions.depositMoney"),
        icon: <PlusIcon size="1.25rem" className="rtl:-scale-x-100" />,
        onClick: () => navigate(`${basePath}/contributions-setup`),
        active: pathname.includes("/contributions-setup"),
      },
      {
        id: "funds",
        text: t("apps.employee.navigation.funds"),
        icon: <LayersIcon size="1.25rem" className="rtl:-scale-x-100" />,
        onClick: () => navigate(`${basePath}/sub-funds`),
        active: pathname.includes("/sub-funds"),
      },
      {
        id: "transactions",
        text: t("apps.employee.navigation.transactions"),
        icon: <ReceiptIcon size="1.25rem" className="rtl:-scale-x-100" />,
        onClick: () => navigate(`${basePath}/transactions`),
        active: pathname.includes("/transactions"),
      },
      {
        id: "withdraw",
        text: t("apps.employee.pages.dashboard.page.actions.withdrawMoney"),
        icon: (
          <ArrowDownToLineIcon size="1.25rem" className="rtl:-scale-x-100" />
        ),
        onClick: () => navigate(`${basePath}/withdrawals`),
        active: pathname.includes("/withdrawals"),
      },
    ];
  }, [employmentId, productAssignmentId, navigate, t, pathname]);

  const buttons = items.map((item) => {
    return <BottomNavigationButton key={item.id} item={item} />;
  });

  return <BottomNavigationBar>{buttons}</BottomNavigationBar>;
};
